import { apiSlice } from "redux/api/apiSlice";

export const search = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    MakaleArama: builder.mutation({
      query: (data) => ({
        url: `/makale-sorgulama`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Modul"],
    }),
    KategoriArama: builder.mutation({
      query: (data) => ({
        url: `/kategori-sorgulama`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Modul"],
    }),
  }),
});

export const { useMakaleAramaMutation, useKategoriAramaMutation } = search;
